// these values correspond to the values in UserRecurringPaymentInterval.php
const INTERVAL = Object.freeze({
  WEEKLY: {
    ID: 1,
    TEXT: "weekly",
    NOUN: "week",
  },
  MONTHLY: {
    ID: 2,
    TEXT: "monthly",
    NOUN: "month",
  },
  QUARTERLY: {
    ID: 3,
    TEXT: "quarterly",
    NOUN: "quarter",
  },
  ANNUALLY: {
    ID: 4,
    TEXT: "annually",
    NOUN: "year",
  },
});

export default INTERVAL;
